const initialState = {
  // initialValues
};

export default function FormValidationReducer(state, action) {
  if (state === undefined) {
    state = initialState;
  }

  switch (action.type) {
    case "VALIDATE_COMPLETE_STORE": {
      const {
        validationForRequiredFields,
        handlePriorityErrorUI,
        showPopupWarnings,
        showEntryTypeConfirmation,
      } = require("./util");

      const uiActionHandlers = {
        handlePriorityError: handlePriorityErrorUI,
        showPopupWarnings,
        showEntryTypeConfirmation,
      };

      const completeStore = action.store;
      const { errors, uiActions } = validationForRequiredFields(
        completeStore,
        action.updateType
      );

      if (uiActions?.length) {
        uiActions.forEach(({ type, data }) => {
          const handler = uiActionHandlers[type];
          if (handler) handler(data);
        });
      }

      action.validate(errors);
      return completeStore;
    }
    default:
      return state;
  }
}
